// Both halves percent-encoded: values are user text as often as ids (schedule
// search `q`, template `search`, link-preview `url`), and a raw `&`, `#` or
// `+` in either half rewrites the query string on the wire.
const pair = (key: string, value: string) =>
  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

export default function queryParamsFromString(
  queryRecord: Record<string, number | string | string[] | undefined>,
): string {
  if (Object.keys(queryRecord).length === 0) return '';
  const query = { ...queryRecord } as any;
  const pairs: string[] = [];
  Object.keys(query).forEach((key) => {
    let value = query[key];
    if (value === true) {
      value = 'true';
    } else if (value === false) {
      value = 'false';
    } else if (Number.isInteger(value)) {
      value = value.toString();
    }
    // Repeated keys, not comma-joined or nested-object dot-notation — this
    // is the only array shape Express/Nest turns back into a real array on
    // the request query object (see `toArray` in `@mfw/common`'s DTOs).
    if (Array.isArray(value)) {
      value.forEach((item: string) => pairs.push(pair(key, item)));
      return;
    }
    if (value === undefined || value === 'undefined' || value === '') {
      return;
    }
    if (typeof value === 'object' && value !== null) {
      const nested = queryParamsFromString(value);
      if (nested) pairs.push(`${key}=${nested}`);
      return;
    }
    pairs.push(pair(key, value));
  });
  return pairs.join('&');
}
